export default __webpack_public_path__ + "static/media/three-icon.a69eccc5.svg";